module.exports = __webpack_public_path__ + "img/pro-m-slider24.3e9b7538.jpg";